<div class="bg-white m-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-end" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 class="text-secondary pb-2">Commentaire</h3>
  </div>
  <div class="modal-body">
    <div>
      <form [formGroup]="commentForm">
        <textarea
          style="width: 450px; height: 180px"
          formControlName="comment"
          type="text"
          class="form-control"
          [class.is-invalid]="submitted && !commentForm.controls?.comment?.valid"
        ></textarea>
        @if (submitted && !commentForm.controls?.comment?.valid) {
          <small class="form-text text-danger">Le commentaire est obligatoire.</small>
        }
      </form>
      @if (options.text) {
        <div class="mt-2">
          <small
            ><strong>{{ options.text }}</strong></small
            >
          </div>
        }
      </div>
      <div class="row mt-3">
        <div class="d-grid col-6 p-0 pe-1">
          <button class="btn btn-secondary d-flex justify-content-center" type="button" (click)="cancel()">Annuler</button>
        </div>
        <div class="d-grid col-6 p-0 ps-1">
          <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="accept()">Valider</button>
        </div>
      </div>
    </div>
  </div>
